export default __webpack_public_path__ + "static/media/ella-olsson-KPDbRyFOTnE-unsplash.95275da2.jpg";